import React from 'react';

import useEvents, {
  INormalizedEvent,
  useExtendedEventType,
} from '../utils/useEvents';
import getEntityLink from '../utils/getEntityLink';

import CountryFlag from 'components/base/CountryFlag';
import { ReactComponent as regionIcon } from 'icons/icon-region.svg';
import { FlagImage } from 'components/base/TopicFiltersDropdown/RegionDropdown/index';
import Span from 'components/elements/span';

import { Link, ListItem, Meta } from '../styles';
import { IEvent } from '../types';

const AllEventsList: React.FC<IProps> = (props) => {
  const { events, countries, getIsNewEvent, regions } = props;
  const extendedEvents = useExtendedEventType(events);
  const normalizedEvents = useEvents(extendedEvents, countries, regions);

  if (!normalizedEvents) return null;

  return (
    <ul>
      {normalizedEvents.map((event: INormalizedEvent) => {
        const {
          eventMessage,
          country,
          entity,
          relatedEntity,
          eventType,
        } = event;
        const { type, id } = entity;

        return (
          <ListItem withBullet={getIsNewEvent(event.id)} key={event.id}>
            <Link to={getEntityLink(type, id, relatedEntity.id, eventType)}>
              {eventMessage}
            </Link>
            <Meta>
              {country?.id?.startsWith('RE-') ? (
                <FlagImage as={regionIcon} width={19} height={19} />
              ) : (
                <CountryFlag small {...country} />
              )}
              {country?.displayName} &#8226; {event.eventTypeCategory}{' '}
              {event?.eventTypeSubCategory ? (
                <>
                  <Span mx={2} fontWeight="600">
                    &middot;
                  </Span>
                  <span>{event?.eventTypeSubCategory}</span>
                </>
              ) : null}
            </Meta>
          </ListItem>
        );
      })}
    </ul>
  );
};

interface IProps {
  events: Array<IEvent>;
  countries: any[];
  getIsNewEvent: (eventId: number) => boolean;
  regions: any[];
}

export default AllEventsList;
